export enum BillingAccountType {
  PerTransaction,
  PerTransactionInvoiceMonthly,
  PerTransactionPerioidicInvoice,
  DebitThreshold,
  Manual
}
